import { render } from "./BootstrapCard.vue?vue&type=template&id=7bec0214"
import script from "./BootstrapCard.vue?vue&type=script&lang=js"
export * from "./BootstrapCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__